import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from "@angular/router";
import { roleIdByName } from "../constants/auth.constants";
import { AuthenticationService } from "../services/authentication.service";

@Injectable({
  providedIn: "root",
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const roles = route.data["roles"] as Array<roleIdByName>;
    const hasAccess = roles.includes(this.authService.currentUserValue.fkIdRol);
    if (!hasAccess) {
      this.router.navigate(["./home"]);
    }
    return hasAccess;
  }
}
